import { Component } from '@angular/core';
@Component({
	templateUrl: './pessoa.component.html',
})

export class PessoaComponent{
}